import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import seriesStore from "../stores/seriesStore";

export default function Header({ selectedShow, setSelectedShow, selectedSeriesList, 
  setSelectedSeriesList, activeHeader, setActiveHeader }) {

    const navigate = useNavigate();
    const serStore = seriesStore();    
    const [query, setQuery] = useState("");
    
    // Mobile overlays
    const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const filteredSeries = serStore.series?.filter((s) =>
        s.title.toLowerCase().includes(query.toLowerCase())
    );

    const [open, setOpen] = useState(false);
    const menuRef = useRef();

    useEffect(() => {
        function handleClick(e) {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, []);
    
    return (
        <div class="header">
            <div>
                <h1 className="scopedLogo" onClick={() => {
                    setSelectedShow(null);
                    setSelectedSeriesList(null);
                    setActiveHeader(null);
                    navigate("/");
                }}>ScopedTV</h1>
            </div>

            {/* Desktop search */}
            <div className="searchBar desktopOnly">
                <input
                    type="text"
                    name="search"
                    placeholder="🔍︎  Search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && filteredSeries?.length > 0) {
                            navigate("/series", { state: { selectedShow: filteredSeries[0] } });
                            setQuery("");
                        }
                    }}
                />
                {query && (
                    <div className="searchResults">
                        {filteredSeries?.length > 0 ? (
                            filteredSeries?.map((s) => (
                            <div key={s._id} className="resultItem" onClick={() => {
                                navigate("/series", { state: { selectedShow: s } });
                                setQuery(""); // clear search box
                            }}>
                                {s.title}
                            </div>
                            ))
                        ) : (
                            <div className="noResults">No matches found</div>
                        )}
                    </div>
                )}
            </div>

            {/* Mobile icons */}
            <div className="mobileIcons">
                <button onClick={() => setMobileSearchOpen(true)}><img src="/assets/icons/search.png"></img></button>
                <button onClick={() => setMobileMenuOpen(true)}><img src="/assets/icons/menu.png"></img></button>
            </div>
       
            {/* Desktop menu */}
            <div className="userMenuContainer desktopOnly" ref={menuRef}>
                 <div
                    onClick={() => setOpen(!open)}
                    className="avatarCircle"
                >
                    <img class="headerIcon" src="/assets/icons/menu.png"></img>
                </div>
               
                {open && (
                    <div className="dropdownMenu">
                        <Link to="/tvgrid" className="dropdownItem">TV Grid</Link> 
                        <Link to="/showoftheday" className="dropdownItem">Show of the Day</Link> 
                        <Link to="/getstarted" className="dropdownItem">Get Started</Link> 
                        <Link to="/about" className="dropdownItem">About Scoped</Link>
                        <Link to="https://forms.gle/AeLbnJRghtrwXErJA" className="dropdownItem" target="_blank">Feedback, etc ↗</Link>
                        <Link to="/logout" className="dropdownItem logout">Log Out</Link>
                    </div>
                )}
            </div>

            {/* MOBILE SEARCH OVERLAY */}
            {mobileSearchOpen && (
                <div className="mobileOverlay">
                    <div className="mobileSearchBar">
                        <input
                            autoFocus
                            type="text"
                            placeholder="search"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && filteredSeries?.length > 0) {
                                    setMobileSearchOpen(false);
                                    navigate("/series", {  state: {
                                    selectedShow: filteredSeries[0],
                                    selectedSeriesList: null,
                                    activeHeader: filteredSeries[0]._id,
                                    query: ""
                                } });
                                }
                            }}
                        />
                        <button onClick={() => setMobileSearchOpen(false)}><img class="headerIconClose" src="/assets/icons/close-white.png"></img></button>
                    </div> 
                    <div className="mobileSearchResults">
                        {filteredSeries?.map((s) => (
                        <div
                            key={s._id}
                            className="mobileSearchResultItem"
                            onClick={() => {
                                setMobileSearchOpen(false);
                                navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id,
                                    query: ""
                                } });
                            }}
                        >
                            {s.title}
                        </div>
                        ))}
                    </div>
                </div>
            )}

            {/* MOBILE MENU OVERLAY */}
            {mobileMenuOpen && (
                <div className="mobileOverlay">
                    <button className="closeBtn" onClick={() => setMobileMenuOpen(false)}>✕</button>
                    <nav className="mobileMenu">
                        <Link to="/tvgrid" onClick={() => setMobileMenuOpen(false)}>TV Grid</Link> 
                        <Link to="/showoftheday" onClick={() => setMobileMenuOpen(false)}>Show of the Day</Link> 
                        <Link to="/getstarted" onClick={() => setMobileMenuOpen(false)}>Get Started</Link>
                        <Link to="/about" onClick={() => setMobileMenuOpen(false)}>About Scoped</Link>
                        <Link to="https://forms.gle/AeLbnJRghtrwXErJA" target="_blank">
                        Feedback ↗
                        </Link>
                        <Link to="/logout">Log Out</Link>
                    </nav>
                </div>
            )}
       
    </div>
    )
}